import { render, staticRenderFns } from "./OrganizationProfileHome.vue?vue&type=template&id=353d8cde&scoped=true&"
import script from "./OrganizationProfileHome.vue?vue&type=script&lang=js&"
export * from "./OrganizationProfileHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353d8cde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('353d8cde')) {
      api.createRecord('353d8cde', component.options)
    } else {
      api.reload('353d8cde', component.options)
    }
    module.hot.accept("./OrganizationProfileHome.vue?vue&type=template&id=353d8cde&scoped=true&", function () {
      api.rerender('353d8cde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/home/components/OrganizationProfileHome.vue"
export default component.exports